import { Logger } from '../../../../generic/utils';
import { wrapperIdentifier } from './common';
import { useEffect } from 'react';
import { wrapperBuilder } from './build';
import { NavigationWrapper } from '../../../../wrappers/NavigationWrapper';

const console = new Logger(wrapperIdentifier);

if (console) {
  //Just for usage
}

wrapperBuilder.getCustomLogicRegisterInstance().setLogic(
  ({
    functions: { loadVinculation },
    variablesHandler: {
      variables: { vinculation },
      variablesSetter,
    },
    componentProps: { fromParam, vinculationId: compVId },
    bindedContexts: { user },
  }) => {
    const { params } = NavigationWrapper.use();
    const vinculationId = compVId || (params || {})[fromParam as string];
    const userId = user && (user._id || user.id);

    useEffect(() => {
      if (userId) {
        if (vinculationId) {
          console.log('ºº Loading vinculations');
          loadVinculation(vinculationId);
        } else {
          console.log('ºº Not jet detected vinculationId');
        }
      } else if (!userId) {
        if (vinculation) {
          variablesSetter('vinculation')(undefined);
          variablesSetter('vinculationApiInstance')(undefined);
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId, vinculationId]);
  }
);
